import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, ProgressBar } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait1 from './svg/wait1.svg'  
import svgWait2 from './svg/wait2.gif'

import i18next from 'i18next';

import { SystemHeader } from './CommonUI';
import { BcanConfig } from './Types';

interface RptRstInfo {
    Rst_Key: string,
    Rst_Line: string,
}

interface PageInfo {
    n: number
}

var GsbFlag: any;


interface CCRGenStkOnHandMainProps {
    gsb: AxiosInstance  
}

const toaster = Toaster.create({
    position: Position.TOP,
})

interface StkNoInfo {
    StkNo1	:string,
    StkNo2	:string,
    StkNo3	:string,
    StkNo4	:string,
    StkNo5	:string,
    StkNo6	:string,
    StkNo7	:string,
    StkNo8	:string,
    StkNo9	:string,
    StkNo10	:string,
    StkNo11	:string,
    StkNo12	:string,
    StkNo13	:string,
    StkNo14	:string,
    StkNo15	:string,
    StkNo16	:string,
    StkNo17	:string,
    StkNo18	:string,
    StkNo19	:string,
    StkNo20	:string,
    StkNo21	:string,
    StkNo22	:string,
    StkNo23	:string,
    StkNo24	:string,
    StkNo25	:string,
    StkNo26	:string,
    StkNo27	:string,
    StkNo28	:string,
    StkNo29	:string,
    StkNo30	:string,
          
}
function CCRGenStkOnHandMain({ gsb }: CCRGenStkOnHandMainProps) {

    let ProgressId2 = ""
    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    
    const { t, i18n } = useTranslation();

    const [ProgressId, setProgressId] = useState("")
    const [ProgressValue, setProgressValue] = useState(0)

    const [Rstdata, setRstdata] = useState([] as RptRstInfo[])
    const [Rstdata2, setRstdata2] = useState([] as RptRstInfo[])
    const [RptHead1, setRptHead1] = useState("")
    const [RptName, setRptName] = useState("")
    const [ExecelFile,setExcelFile] =  useState("")
    const [RptNameNo, setRptNameNo] = useState(0)
    const [aRptNameNo, setaRptNameNo] = useState([] as PageInfo[])
    const [RptLogName, setRptLogName] = useState("")
    const [RptLogName2, setRptLogName2] = useState("")
    const [ShowWait, setShowWait] = useState(false)
    const [ShowRpt, setShowRpt] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowOK, setShowOK] = useState(true)
 
    const [s_ClCode1, sets_ClCode1] = useState("")
    const [s_ClCode2, sets_ClCode2] = useState("")
    const [DataFormatValue, setDataFormatValue] = useState(true)
    const [CSVFormat, setCSVFormat] = useState("0")
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    //const [cPrintMode, setcPrintMode] = useState("PS")

    const [LineLimit, setLineLimit] = useState(54 - 7)

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")

    const [NoOfSubmission, setNoOfSubmission] = useState("1")

    const [DateOfSubmission, setDateOfSubmission] = useState("")

    const [DateOfUploadDate, setDateOfUploadDate] = useState("")

     


    const [DateOfTrans, setDateOfTrans] = useState("")
	const [StkNoValue , setStkValue] = useState([])

    const [s_Date1, sets_Date1] = useState(utils.formatNumber(new Date()))
    const [s_Date2, sets_Date2] = useState(utils.formatNumber(new Date()))
    const [currentAc, setCurrentAc] = useState({} as BcanConfig) 
    const [currentStkNoArry, setStkNoArry] = useState({} as StkNoInfo) 
  
    const[GSBx_USER,setGSBx_USER] = useState(false)
    const[HKIDR_USER1,setHKIDR_USER1] = useState(false)

    const [OwnRefNoValue,setOwnRefNoValue] = useState("1234")
    const [FileIndicatorValue,setFileIndicatorValue] = useState("1")
    const [DateOfUpload, setDateOfUpload] = useState("")

    const [StkNoValueArry, setStkNoValueArry] = useState([])
    const [StkNoValue1, setStkNoValue1] = useState("")
    const [StkNoValue2, setStkNoValue2] = useState("")
    const [StkNoValue3, setStkNoValue3] = useState("")
    const [StkNoValue4, setStkNoValue4] = useState("")

    const [StkNoValue5, setStkNoValue5] = useState("")
    const [StkNoValue6, setStkNoValue6] = useState("")
    const [StkNoValue7, setStkNoValue7] = useState("")
    const [StkNoValue8, setStkNoValue8] = useState("")
    const [StkNoValue9, setStkNoValue9] = useState("")
    const [StkNoValue10, setStkNoValue10] = useState("")
    const [StkNoValue11, setStkNoValue11] = useState("")
    const [StkNoValue12, setStkNoValue12] = useState("")
    const [StkNoValue13, setStkNoValue13] = useState("")
    const [StkNoValue14, setStkNoValue14] = useState("")
    const [StkNoValue15, setStkNoValue15] = useState("")
    const [StkNoValue16, setStkNoValue16] = useState("")
    const [StkNoValue17, setStkNoValue17] = useState("")
    const [StkNoValue18, setStkNoValue18] = useState("")
    const [StkNoValue19, setStkNoValue19] = useState("")
    const [StkNoValue20, setStkNoValue20] = useState("")
    const [StkNoValue21, setStkNoValue21] = useState("")
    const [StkNoValue22, setStkNoValue22] = useState("")
    const [StkNoValue23, setStkNoValue23] = useState("")
    const [StkNoValue24, setStkNoValue24] = useState("")
    const [StkNoValue25, setStkNoValue25] = useState("")
    const [StkNoValue26, setStkNoValue26] = useState("")
    const [StkNoValue27, setStkNoValue27] = useState("")
    const [StkNoValue28, setStkNoValue28] = useState("")
    const [StkNoValue29, setStkNoValue29] = useState("")
    const [StkNoValue30, setStkNoValue30] = useState("")



    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
} else {
    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
}
                setGSBx_USER(GsbFlag.GSBx_USER);
                setHKIDR_USER1(GsbFlag.HKIDR_USER1);
                setEnter2tab(GsbFlag.Enter2tab) ;
                setCSVFormat(GsbFlag.CSVFormat) ;
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    
    useEffect(() => {
        setShowRpt(false)
        setShowNoRecord(false)
        setShowOK(true)
    }, [s_Date1, s_Date2, DateOfTrans, FileIndicatorValue, OwnRefNoValue, DataFormatValue,DateOfUploadDate])
 
 
    useEffect(() => {
        (async () => {
            try {
               
                const res = await gsb.post('/Master',
                {   sb_data: {
                    },
                    cPgmId: "CCRMast",
                    cAction: "GetUploadDate",
                });    

                if ( res.data.count > 0 ) {
                    setDateOfUploadDate(res.data.data[0].d_Upload_DATE)                   
                    setDateOfTrans(res.data.data[0].d_TRAN_DATE) 
                } else {

                }
            } catch (error) {
                //setCanPorcess(false)
                showError(error)
            }
        })()

    }, [gsb, TRAN_DATE, SETL_DATE])
 


    useEffect(() => {
        const refreshTasks = async () => {
            ProgressId2 = ProgressId
            if ( ProgressId2.trim().length > 0 ) {
                try {
                    const res = await gsb.post('/Progresslist', {p_data: ProgressId2})
                    let pValue = 0
                    if ( res.data.count > 0 ) {
                        if ( res.data.data[0].id === ProgressId2 ) {
                            pValue = res.data.data[0].progressValue / res.data.data[0].progressMax
                            //console.log("Progresslist: ", res.data.data[0].progressValue, res.data.data[0].progressMax) 
                            //console.log("Progresslist pValue: ", pValue) 
                            setProgressValue(pValue)
                        }
                        if (res.data.data[0].status > 0 ) {
                            clearInterval(timer)
                        }
                    }
                } catch (error) {
                    utils.showError(error)
                }
            }
        }
        let timer = setInterval(refreshTasks, 20*1000)
        return () => {clearInterval(timer)}
    }, [gsb, ProgressId, nPage])

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()
 
        //StkNoValue
        currentStkNoArry.StkNo1 = StkNoValue1
        currentStkNoArry.StkNo2 = StkNoValue2
        currentStkNoArry.StkNo3 = StkNoValue3
        currentStkNoArry.StkNo4 = StkNoValue4
        currentStkNoArry.StkNo5 = StkNoValue5
        currentStkNoArry.StkNo6 = StkNoValue6
        currentStkNoArry.StkNo7 = StkNoValue7
        currentStkNoArry.StkNo8 = StkNoValue8
        currentStkNoArry.StkNo9 = StkNoValue9
        currentStkNoArry.StkNo10 = StkNoValue10
        currentStkNoArry.StkNo11 = StkNoValue11
        currentStkNoArry.StkNo12 = StkNoValue12
        currentStkNoArry.StkNo13 = StkNoValue13
        currentStkNoArry.StkNo14 = StkNoValue14
        currentStkNoArry.StkNo15 = StkNoValue15
        currentStkNoArry.StkNo16 = StkNoValue16
        currentStkNoArry.StkNo17 = StkNoValue17
        currentStkNoArry.StkNo18 = StkNoValue18
        currentStkNoArry.StkNo19 = StkNoValue19
        currentStkNoArry.StkNo20 = StkNoValue20
        currentStkNoArry.StkNo21 = StkNoValue21
        currentStkNoArry.StkNo22 = StkNoValue22
        currentStkNoArry.StkNo23 = StkNoValue23
        currentStkNoArry.StkNo24 = StkNoValue24
        currentStkNoArry.StkNo25 = StkNoValue25
        currentStkNoArry.StkNo26 = StkNoValue26
        currentStkNoArry.StkNo27 = StkNoValue27
        currentStkNoArry.StkNo28 = StkNoValue28
        currentStkNoArry.StkNo29 = StkNoValue29
        currentStkNoArry.StkNo30 = StkNoValue30

        setShowOK(false)
        setShowWait(true)
        setShowNoRecord(false)
        setShowRpt(false)
        setRstdata([])
        setRptHead1("")
        setRptName("")
        
        setExcelFile("")

        setRptLogName("")
        setRptLogName2("")
        setnPage(1)
        ProgressId2 = utils.genUUID()
        setProgressId(ProgressId2)
        setProgressValue(0)

        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                console.log("currentStk onsubmit called", currentStkNoArry)
                const res = await gsb.post('/Master',
                    {    sb_data: {
                        ProgressId: ProgressId2,
                        s_Date1 : s_Date1,
                        s_Date2 : s_Date2,                    
                        s_RptName: RptName,   
                        s_ExecelFile: ExecelFile,                                   
                        s_OwnRefNoValue : OwnRefNoValue,         
                        s_DateOfUploadDate: DateOfUpload,
                        s_FileIndicatorValue: FileIndicatorValue,
                        s_Stk :currentStkNoArry,
                        DataFormat: DataFormatValue,
                        nPage: nPage,
                        cPrintMode: "PS",
                        limit: LineLimit,
                        },
                        cPgmId: "CCRMast",
                        cAction: "GenByStkOnHand",  
                    });

                console.log("res.data.data: ", res.data.data) 
                if ( res.data.count > 0 ) {
                    setRstdata2([])
                    for (let j = 0; j < res.data.Rptdata.length; j++) {
                        Rstdata2.push({Rst_Key: res.data.Rptdata[j][0], Rst_Line: res.data.Rptdata[j][1]})
                    }
                    setShowWait(false)
                    setShowNoRecord(false)
                    setShowRpt(true)
                    setRstdata(Rstdata2)
                    console.log("Rstdata: ", Rstdata) 
                    setRptHead1(res.data.Rpthead1)
                    setRptName(res.data.RptName)
                    setExcelFile(res.data.ExecelFile)
                    setRptLogName2(res.data.RptLogName2)
                    setRptLogName(res.data.RptLogName)
                    setRptNameNo(res.data.RptNameNo)
                    //console.log("RptName: ", RptName) 
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(res.data.TotalPageNo)
                        for ( let j = 1; j <= res.data.TotalPageNo; j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                        if (res.data.RptNameNo > 0 ) {
                            for ( let j = 1 ; j <= res.data.RptNameNo; j++ ){
                                aRptNameNo.push({n: j});
                            }
                            setRptName(res.data.RptName.replace(".pdf",""))
                        }
                    }
                } else {
                    setShowWait(false)
                    setShowNoRecord(true)
                    setShowRpt(false)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

 
    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }
    const Banner_OTCR2 =       
    <H3>Generate "CORP COMM RECIPIENT" by Stock On Hand</H3>


    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let RptNameaRef = <>
        { RptNameNo > 0 && <div> Download / Print &nbsp;
            {aRptNameNo.map((no, j) => 
                <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}-${no.n}.pdf`}> <span id="RPageNo2" onClick={() => {} }> {no.n} &nbsp; </span> </a>
            )}
        </div> }
        { RptNameNo <= 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print </a>}
    </>

 
        let list = <>
        <div className="Spacing-V-16" />
        {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download Text</a>}
        &nbsp; &nbsp; {ExecelFile.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${ExecelFile}`}>Download Excel</a>} &nbsp;  &nbsp;{RptLogName2.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName2}&inline`}>View CCR file log</a>}

        &nbsp; &nbsp; {<a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`}>View Log</a>} &nbsp; &nbsp;
   

        {ShowRpt && ! DataFormatValue && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead id="rpt_th_r">
                <tr >
                    { ! DataFormatValue && <th className="RCol-Head_p">
                            {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download</a>}
                        </th>
                    }
                </tr>                    
                <tr>
                    <td className="RCol-Head1">{RptHead1}</td>
                </tr>                    
            </thead>
            <tbody id="rpt_tr">
                {Rstdata.map((rpt, i) =>
                    <tr key={i} onDoubleClick={() => { }}>
                        <td className="RCol-Rpt" onClick={() => {  }}>{rpt.Rst_Line}</td>
                    </tr>
                )}
            </tbody>
            <div className="Spacing-V-16" />
            {ShowRpt && ! DataFormatValue && Pagination}
        </HTMLTable>
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >

                    {/*<H3>Export OTCR Reporting File (D/W only) in History (Selected Trans date: {DateOfTrans}) </H3>*/}
                    {Banner_OTCR2}
                    <div className="Spacing-V-16" />
                   
                    <div className="Row">
                      
                        <FormGroup className="Col-1-2" label={t('Start Record Date')} labelFor="inputStkRecordDate1">
                            <InputGroup   id="inputDoB" name="s_Date1" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" defaultValue={DateOfTrans}    onChange={utils.handleStringChange(s => sets_Date1(s))} />      
                        </FormGroup>
                        <FormGroup className="Col-3-2" label={t('Record Date')} labelFor="inputStkRecordDate2">
                            <InputGroup   id="inputDoB" name="s_Date2" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" defaultValue={DateOfTrans}    onChange={utils.handleStringChange(s => sets_Date2(s))} />      
                        </FormGroup>  
                        
                        <FormGroup className="Col-1-2" label="Own Ref No." labelFor="inputNoOfSubmission">
                        <InputGroup
                            id="inputNoOfSubmission"
                            autoFocus
                            placeholder="Own Ref No..."
                            value={OwnRefNoValue}
                            onChange={utils.handleStringChange(s => setOwnRefNoValue(s))}
                        />                    
                        </FormGroup>


                        <FormGroup className="Col-1-2" label={t('Upload Date')} labelFor="inputUpload_Date">
                            <InputGroup   id="inputDoB" name="d_Upload_Date" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" defaultValue={DateOfUploadDate}    onChange={utils.handleStringChange(s => setDateOfUploadDate(s))} />      
                        </FormGroup>

                        <FormGroup className="Col-1-2" label="File Indicator" labelFor="inputFileIndicator">
                        <InputGroup
                            id="inputFileIndicator"
                            autoFocus
                            placeholder="File Indicator..."
                            value={FileIndicatorValue}
                            onChange={utils.handleStringChange(s => setFileIndicatorValue(s))}
                        />                    
                        </FormGroup>
                    </div>
                    <div className="Row">
                        <FormGroup className="Col-1-2" label="Stock No.1" labelFor="inputStkNoValue1">
                            <InputGroup id="inputStkNoValue1" name="StkNo1" autoFocus value={StkNoValue1} onChange={utils.handleStringChange(s => setStkNoValue1(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-3-2" label="Stock No.2" labelFor="inputStkNoValue2">
                            <InputGroup id="inputStkNoValue2" name="StkNo2" autoFocus value={StkNoValue2} onChange={utils.handleStringChange(s => setStkNoValue2(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-5-2" label="Stock No.3" labelFor="inputStkNoValue3">
                            <InputGroup id="inputStkNoValue3" name="StkNo3" autoFocus value={StkNoValue3} onChange={utils.handleStringChange(s => setStkNoValue3(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-7-2" label="Stock No.4" labelFor="inputStkNoValue4">
                            <InputGroup id="inputStkNoValue4" name="StkNo4" autoFocus value={StkNoValue4} onChange={utils.handleStringChange(s => setStkNoValue4(s))} /> 
                        </FormGroup>        
                        <FormGroup className="Col-9-2" label="Stock No.5" labelFor="inputStkNoValue5">
                            <InputGroup id="inputStkNoValue5" name="StkNo5" autoFocus value={StkNoValue5} onChange={utils.handleStringChange(s => setStkNoValue5(s))} /> 
                        </FormGroup>
                    </div>    

                    <div className="Row">              
                        <FormGroup className="Col-1-2" label="Stock No.6" labelFor="inputStkNoValue6">
                            <InputGroup id="inputStkNoValue6" name="StkNo6" autoFocus value={StkNoValue6} onChange={utils.handleStringChange(s => setStkNoValue6(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-3-2" label="Stock No.7" labelFor="inputStkNoValue7">
                            <InputGroup id="inputStkNoValue7" name="StkNo7" autoFocus value={StkNoValue7} onChange={utils.handleStringChange(s => setStkNoValue7(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-5-2" label="Stock No.8" labelFor="inputStkNoValue8">
                            <InputGroup id="inputStkNoValue8" name="StkNo8" autoFocus value={StkNoValue8} onChange={utils.handleStringChange(s => setStkNoValue8(s))} /> 
                        </FormGroup>        
                        <FormGroup className="Col-7-2" label="Stock No.9" labelFor="inputStkNoValue9">
                            <InputGroup id="inputStkNoValue9" name="StkNo9" autoFocus value={StkNoValue9} onChange={utils.handleStringChange(s => setStkNoValue9(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-9-2" label="Stock No.10" labelFor="inputStkNoValue10">
                            <InputGroup id="inputStkNoValue10" name="StkNo10" autoFocus value={StkNoValue10} onChange={utils.handleStringChange(s => setStkNoValue10(s))} /> 
                        </FormGroup>
                    </div>    


                    <div className="Row">
        
                        <FormGroup className="Col-1-2" label="Stock No.11" labelFor="inputStkNoValue11">
                            <InputGroup id="inputStkNoValue11" name="StkNo11" autoFocus value={StkNoValue11} onChange={utils.handleStringChange(s => setStkNoValue11(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-3-2" label="Stock No.12" labelFor="inputStkNoValue12">
                            <InputGroup id="inputStkNoValue12" name="StkNo12" autoFocus value={StkNoValue12} onChange={utils.handleStringChange(s => setStkNoValue12(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-5-2" label="Stock No.13" labelFor="inputStkNoValue13">
                            <InputGroup id="inputStkNoValue13" name="StkNo13" autoFocus value={StkNoValue13} onChange={utils.handleStringChange(s => setStkNoValue13(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-7-2" label="Stock No.14" labelFor="inputStkNoValue14">
                            <InputGroup id="inputStkNoValue14" name="StkNo14" autoFocus value={StkNoValue14} onChange={utils.handleStringChange(s => setStkNoValue14(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-9-2" label="Stock No.15" labelFor="inputStkNoValue15">
                            <InputGroup id="inputStkNoValue15" name="StkNo15" autoFocus value={StkNoValue15} onChange={utils.handleStringChange(s => setStkNoValue15(s))} /> 
                        </FormGroup>        
                    </div>    


                    <div className="Row">
                        <FormGroup className="Col-1-2" label="Stock No.16" labelFor="inputStkNoValue16">
                            <InputGroup id="inputStkNoValue16" name="StkNo16"  autoFocus value={StkNoValue16} onChange={utils.handleStringChange(s => setStkNoValue16(s))} /> 
                        </FormGroup>     
                        <FormGroup className="Col-3-2" label="Stock No.17" labelFor="inputStkNoValue17">
                            <InputGroup id="inputStkNoValue17" name="StkNo17" autoFocus value={StkNoValue17} onChange={utils.handleStringChange(s => setStkNoValue17(s))} /> 
                        </FormGroup>    
                        <FormGroup className="Col-5-2" label="Stock No.18" labelFor="inputStkNoValue18">
                            <InputGroup id="inputStkNoValue18" name="StkNo18" autoFocus value={StkNoValue18} onChange={utils.handleStringChange(s => setStkNoValue18(s))} /> 
                        </FormGroup>    
                        <FormGroup className="Col-7-2" label="Stock No.19" labelFor="inputStkNoValue19">
                            <InputGroup id="inputStkNoValue19" name="StkNo19" autoFocus value={StkNoValue19} onChange={utils.handleStringChange(s => setStkNoValue19(s))} /> 
                        </FormGroup>    
                        <FormGroup className="Col-9-2" label="Stock No.20" labelFor="inputStkNoValue20">
                            <InputGroup id="inputStkNoValue20" name="StkNo20" autoFocus value={StkNoValue20} onChange={utils.handleStringChange(s => setStkNoValue20(s))} /> 
                        </FormGroup>    
                    </div>
                    <div className="Row">
        
                        <FormGroup className="Col-1-2" label="Stock No.21" labelFor="inputStkNoValue21">
                            <InputGroup id="inputStkNoValue21" name="StkNo21" autoFocus value={StkNoValue21} onChange={utils.handleStringChange(s => setStkNoValue21(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-3-2" label="Stock No.22" labelFor="inputStkNoValue22">
                            <InputGroup id="inputStkNoValue22" name="StkNo22" autoFocus value={StkNoValue22} onChange={utils.handleStringChange(s => setStkNoValue22(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-5-2" label="Stock No.23" labelFor="inputStkNoValue23">
                            <InputGroup id="inputStkNoValue23" name="StkNo23" autoFocus value={StkNoValue23} onChange={utils.handleStringChange(s => setStkNoValue23(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-7-2" label="Stock No.24" labelFor="inputStkNoValue24">
                            <InputGroup id="inputStkNoValue24" name="StkNo24" autoFocus value={StkNoValue24} onChange={utils.handleStringChange(s => setStkNoValue24(s))} /> 
                        </FormGroup>
                        <FormGroup className="Col-9-2" label="Stock No.25" labelFor="inputStkNoValue25">
                            <InputGroup id="inputStkNoValue25" name="StkNo24" autoFocus value={StkNoValue25} onChange={utils.handleStringChange(s => setStkNoValue25(s))} /> 
                        </FormGroup>        
                    </div>    


                    <div className="Row">
                        <FormGroup className="Col-1-2" label="Stock No.26" labelFor="inputStkNoValue26">
                            <InputGroup id="inputStkNoValue26" name="StkNo26" autoFocus value={StkNoValue26} onChange={utils.handleStringChange(s => setStkNoValue26(s))} /> 
                        </FormGroup>     
                        <FormGroup className="Col-3-2" label="Stock No.27" labelFor="inputStkNoValue27">
                            <InputGroup id="inputStkNoValue27" name="StkNo27" autoFocus value={StkNoValue27} onChange={utils.handleStringChange(s => setStkNoValue27(s))} /> 
                        </FormGroup>    
                        <FormGroup className="Col-5-2" label="Stock No.28" labelFor="inputStkNoValue28">
                            <InputGroup id="inputStkNoValue28" name="StkNo28" autoFocus value={StkNoValue28} onChange={utils.handleStringChange(s => setStkNoValue28(s))} /> 
                        </FormGroup>    
                        <FormGroup className="Col-7-2" label="Stock No.29" labelFor="inputStkNoValue29">
                            <InputGroup id="inputStkNoValue29" name="StkNo29" autoFocus value={StkNoValue29} onChange={utils.handleStringChange(s => setStkNoValue29(s))} /> 
                        </FormGroup>    
                        <FormGroup className="Col-9-2" label="Stock No.30" labelFor="inputStkNoValue30">
                            <InputGroup id="inputStkNoValue30" name="StkNo30" autoFocus value={StkNoValue30} onChange={utils.handleStringChange(s => setStkNoValue30(s))} /> 
                        </FormGroup>    
                    </div>
                                                                                                                                                                                 
                    <div className="Row">
                        {currentAc.d_OTCR_FileType == "TXT" &&
                        <FormGroup className="Col-1-2" >
                            <div>Text Format</div>
                        </FormGroup>}
                        {currentAc.d_OTCR_FileType == "ZIP" &&
                        <FormGroup className="Col-1-2" >
                            <div>ZIP Format</div>
                        </FormGroup>}
                    </div>
                    <div className="Row">
                        <Button disabled={! ShowOK} type="submit">OK</Button>
                    </div>
                </Card>
                {/* {ShowWait && <div>{imgWait}</div> } */}
                {ShowWait && <div className="TCol-Progress2">Progress ...</div> }
                {ShowWait && <div className="TCol-Progress2"><ProgressBar stripes={false} animate={false} value={ProgressValue} /></div> }
                {ShowNoRecord && <p>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup className="Col-1-3"  >
                            <span id="Err_msg">No Record found !!!</span>
                        </FormGroup>
                    </div>
                </p>
                }
                {ShowRpt && list}
            </form>
        </>
    );
}
 
export default CCRGenStkOnHandMain